export function generateMarketName(assetSymbol, yieldName, maturityTime) {
  const duration = maturityTime / 86400;

  return `${duration} day ${assetSymbol} (${yieldName})`;
}
